import React from "react";
import Dash_JobCard from "./dash_JobCard";
import Pagination from "./Pagination";
import { useState, useEffect } from "react";
import axios from "axios";
import { fetchAllJobs } from "../services/jobsApi";
import { fetchCandidateApplications } from "../services/jobsApi";

export default function JobList({ searchTerm }) {
  {/*const jobs = [
    {
      id: 1,
      title: "Frontend Developer",
      company: "TechSoft Solutions",
      companyLogo: "https://via.placeholder.com/60",
      yoe: "1-2 years",
      location: "Bangalore",
      salary: "3 - 5 LPA",
      description: "Looking for React JS developer with UI experience.",
      skills: ["React", "JavaScript", "CSS"],
      postedAt: "2025-02-01",
      postedBy: "Ramesh HR",
    },
    {
      id: 2,
      title: "Backend Developer",
      company: "WebCloud Pvt Ltd",
      companyLogo: "https://via.placeholder.com/60",
      yoe: "0-1 year",
      location: "Chennai",
      salary: "2.5 - 4 LPA",
      description: "Node.js backend role involving API development.",
      skills: ["Node.js", "MongoDB", "API"],
      postedAt: "2025-02-05",
      postedBy: "Priya HR",
    },
    {
      id: 3,
      title: "Full Stack Developer",
      company: "FutureTech Innovations",
      companyLogo: "https://via.placeholder.com/60",
      yoe: "1 year",
      location: "Hyderabad",
      salary: "4 - 6 LPA",
      description: "Full stack development using React & Node.",
      skills: ["React", "Node.js", "SQL"],
      postedAt: "2025-02-10",
      postedBy: "Karthik HR",
    },
    {
      id: 4,
      title: "Python Developer",
      company: "ABC solutions",
      companyLogo: "https://via.placeholder.com/60",
      yoe: "1 year",
      location: "Hyderabad",
      salary: "6 - 8 LPA",
      description: "Python and oops concepts and Flask/Django.",
      skills: ["Django", "Python", "Flask"],
      postedAt: "2025-02-10",
      postedBy: "abc HR",
    },   
  ];
  const filteredJobs = jobs.filter(job =>
    job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.skills.join(" ").toLowerCase().includes(searchTerm.toLowerCase())
  ); */}
  // After integrating backend, fetch jobs from API
  const JOBS_PER_PAGE = 6;
  const [currentPage, setCurrentPage] = useState(1);   //added on 17-12-2025



  const [jobs, setJobs] = useState([]);
  const [applications, setApplications] = useState([]);  // added on 26-11-2025

  // added on 25-11-2025
  {/*useEffect(() => {
    const fetchJobs = async () => {
      try {
        //const res = await axios.get("http://localhost:8000/api/jobs");
        const res = await axios.get("http://144.91.102.67:8001/api/jobs");
        setJobs(res.data);
      } catch (error) {
        console.error("Failed to load jobs:", error);
      }
    };

    fetchJobs();
  }, []);*/}

  // added on 26-11-2025
  useEffect(() => {
  async function load() {
    try {
      const [jobsData, applicationsData] = await Promise.all([
        fetchAllJobs(),                 // ✅ correct function
        fetchCandidateApplications(),   // ✅ GET /api/applications/me
      ]);

      const appliedJobIds = applicationsData.map(a => a.job_id);

      const updated = jobsData.map(job => ({
        ...job,
        applied: appliedJobIds.includes(job.id)   // ✅ mark applied
      }));

      setJobs(updated);
      setApplications(applicationsData);
    } catch (err) {
      console.error("Load failed:", err);
    }
  }

  load();
}, []);

  const profile = JSON.parse(localStorage.getItem("ProfileHighlight"));


  const filteredJobs = jobs
  .filter(job =>
    job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.skills.join(" ").toLowerCase().includes(searchTerm.toLowerCase())
  )
  .sort((a, b) => {
    if (!profile || !profile.preferences) return 0;

    const domains = profile.preferences.domain?.map(d => d.toLowerCase()) || [];
    const locations = profile.preferences.locations?.map(l => l.toLowerCase()) || [];

    const aMatch =
      domains.some(d => a.title.toLowerCase().includes(d)) ||
      locations.some(l => a.location.toLowerCase().includes(l));

    const bMatch =
      domains.some(d => b.title.toLowerCase().includes(d)) ||
      locations.some(l => b.location.toLowerCase().includes(l));

    return bMatch - aMatch; // ✅ preference first
  });

  const totalPages = Math.max(1, Math.ceil(filteredJobs.length / JOBS_PER_PAGE));
  const start = (currentPage - 1) * JOBS_PER_PAGE;
  const pageJobs = filteredJobs.slice(start, start + JOBS_PER_PAGE);

  return (
    <div style={{ padding: "20px" }}>
      <div className="job-grid">
        {pageJobs.map((job) => (
          <Dash_JobCard key={job.id} job={job} layout="grid" />
        ))}
      </div>
      <div className="pagination-wrapper">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
    </div>
  );
}
